import { deserializeDriver, SerializedDriver } from "../../entities/routing/Driver";
import { apiServer } from "../server/Setting";
import { WebClient } from "../server/WebClient";


export const DriverService = {
	getAll: () =>  WebClient.Get(`${apiServer}/api/drivers`, (d: SerializedDriver[])=> d.map(deserializeDriver)),
	remove: (driverId: string) => WebClient.Delete(`${apiServer}/api/drivers/${driverId}`)
}
